export default __webpack_public_path__ + "static/media/op-ku-logotype-l.ca793396.svg";